import React from 'react'
import {connect} from 'react-redux'
import {reactTableColumn} from '../../helpers/reactTable'
import CFXProReactTable from '../cfxProReactTable'
import {HEIFER_INDEX} from '../../constants'
import {deleteProjection} from '../../actions'
import {withRouter} from 'react-router'
import {syncObjectDelete} from '../../helpers/syncing'
import api from '../../api'
import {actionButtons} from '../../helpers/button'

@withRouter
@connect((state) => {
  const {
    app: {isLoggedIn},
    userData: {projections, userId},
  } = state

  return {
    isLoggedIn,
    userId,
    projections,
  }
})
@api
class PriceProjectionsList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      deletingId: null,
    }
  }

  localDeletePriceProjection = (id) => {
    const {isLoggedIn, userId, apiInstance, dispatch} = this.props

    if (isLoggedIn) {
      this.setState({deletingId: id})
      syncObjectDelete(apiInstance, {userId, id}, dispatch, 'Price Projection')
        .then((response) => {
          this.setState({deletingId: null})
        })
        .catch((err) => {
          this.setState({deletingId: null})
        })
    } else {
      dispatch(deleteProjection(id))
    }
  }

  render() {
    const {projections} = this.props
    const {deletingId} = this.state
    const data = Object.values(projections)
    return (
      <div>
        <CFXProReactTable
          fixedHeaders={true}
          titleText="PRICE PROJECTION"
          rightButtonIconName="fa-plus-circle"
          rightButtonCallback={() => {
            this.props.history.push('/price/projections/calculator')
          }}
          data={data}
          className="-striped -highlight"
          showPagination={data != null && data.length > 10}
          defaultPageSize={10}
          columns={[
            reactTableColumn('Scenario', 'sellingWeight', '', (cell) => (
              <div className="cell-value">
                {cell.original.sellingWeight}lb{' '}
                {cell.original.type === HEIFER_INDEX ? 'Heifer' : 'Steer'}
              </div>
            )),
            reactTableColumn('Sale Date', 'saleDate'),
            reactTableColumn('Cost of Barley $/Tonne', 'costOfBarley'),
            reactTableColumn('Projected Price', 'projectedMarketPricePerLb'),
            reactTableColumn('Actions', 'id', '', ({row}) => (
              <div className="cell-value">
                {actionButtons(
                  row,
                  deletingId,
                  '/breakeven/projections/calculator/' + row.id,
                  this.localDeletePriceProjection,
                )}
              </div>
            )),
          ]}
        />
      </div>
    )
  }
}

export default PriceProjectionsList



// WEBPACK FOOTER //
// ./src/components/price/projectionsList.js